module.exports = __webpack_public_path__ + "img/icon (6).0175d317.png";